// extracted by mini-css-extract-plugin
export var titleStyle = "title-module--titleStyle--4g2fZ";
export var datePosted = "title-module--datePosted--aexEP";